import { ArrowRightIcon, CalendarIcon, ChevronLeftIcon, ChevronRightIcon } from '@/assets';
import { formatDateTime } from '@/utils';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import DatePicker from 'react-datepicker';

interface IProps {
  callback: (arr: { value: string; key: string }[]) => void;
  startTime: string;
  endTime: string;
}

const RangePicker: React.FC<IProps> = ({ callback, startTime, endTime }) => {
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  useEffect(() => {
    if (startTime && endTime) {
      setStartDate(new Date(parseInt(startTime) * 1000).setHours(0, 0, 0, 0));
      setEndDate(new Date(parseInt(endTime) * 1000).setHours(23, 59, 59, 999));
    }
  }, [startTime, endTime]);
  const onChange = (dates: any) => {
    const [start, end] = dates;
    if (start && end) {
      const arr = [
        { value: String(new Date(start).setHours(0, 0, 0, 0) / 1000), key: 'startTime' },
        { value: String(new Date(end).setHours(23, 59, 59, 0) / 1000), key: 'endTime' },
      ];
      callback(arr);
    }
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <div className="titan-rangepicker">
      <div className="titan-rangepicker__view">
        <div className="view-item">
          <span>{startDate ? formatDateTime(moment(startDate)) : ''}</span>
          <ArrowRightIcon />
        </div>
        <div className="view-item">
          <span>{endDate ? formatDateTime(moment(endDate)) : ''}</span>
          <CalendarIcon />
        </div>
      </div>
      <DatePicker
        renderCustomHeader={({ monthDate, customHeaderCount, decreaseMonth, increaseMonth }) => (
          <div style={{ margin: '5px 0px' }}>
            <button
              aria-label="Previous Month"
              className={'react-datepicker__navigation react-datepicker__navigation--previous'}
              onClick={decreaseMonth}
            >
              <ChevronLeftIcon />
            </button>
            <span className="react-datepicker__current-month">
              {monthDate.toLocaleString('en', {
                month: 'long',
                year: 'numeric',
              })}
            </span>
            <button
              aria-label="Next Month"
              className={'react-datepicker__navigation react-datepicker__navigation--next'}
              onClick={increaseMonth}
            >
              <ChevronRightIcon />
            </button>
          </div>
        )}
        selected={startDate}
        onChange={onChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        inline
      />
    </div>
  );
};

export default RangePicker;
